package org.hs_soft.runmynesto.pages.home.sub_page.product.component.tabs.product_general_tab.component

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import org.hs_soft.runmynesto.domain.config.*
import org.hs_soft.runmynesto.domain.util.Res
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.silk.components.graphics.Image
import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.virtual_card.virtual_card_config.GetVirtualCardConfig
import org.hs_soft.runmynesto.domain.util.Constants
import org.hs_soft.runmynesto.pages.components.VectorIcon
import org.jetbrains.compose.web.css.*


@Composable
fun ProductTabDataAssistantContent(
    info: GetVirtualCardConfig?,
    onChatButtonClick: (String) -> Unit,
    onCloseDataAssistantButtonClick: () -> Unit
) {
    var hoverState by remember { mutableStateOf(false) }
    Box(
        modifier = Modifier
            .position(Position.Fixed)
            .right(Dimen.extraLargePadding)
            .bottom(Dimen.extraLargePadding)
            .zIndex(Constants.ZIndex.largeZIndex)
            .onMouseEnter { hoverState = true }
            .onMouseLeave { hoverState = false }
    ) {
        Box(
            modifier = Modifier
                .size(Dimen.dataAssistantButtonSize.px)
                .position(Position.Relative)
                .onClick { onChatButtonClick(info!!.issuerEmail ?: "") }
        ) {
            HoverAnimatedImage(
                staticImageUrl = Res.PathIcon.restoMateStatic,
                animatedImageUrl = Res.PathIcon.restoMateAnimated,
                hoverState = hoverState,
                onCloseDataAssistantButtonClick = onCloseDataAssistantButtonClick
            )
        }
    }
}

@Composable
fun HoverAnimatedImage(
    staticImageUrl: String,
    animatedImageUrl: String,
    onCloseDataAssistantButtonClick: () -> Unit,
    hoverState: Boolean
) {
    Box(
        modifier = Modifier
            .size(Dimen.dataAssistantButtonSize.px)
            .backgroundColor(Color.white)
            .border(width = Dimen.smallThickness, style = LineStyle.Solid, color = Theme.Divider.rgb)
            .borderRadius(50.percent)
            .position(Position.Relative)
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .right(Dimen.largePadding)
            .bottom(Dimen.semiLargePadding)
            .justifyContent(JustifyContent.Center)
    ) {
        Image(
            src = staticImageUrl,
            modifier = Modifier
                .fillMaxSize()
                .cursor(Cursor.Pointer)
                .position(Position.Absolute)
                .zIndex(Constants.ZIndex.smallZIndex)
        )
        if (hoverState) {
            Image(
                src = animatedImageUrl,
                modifier = Modifier
                    .fillMaxSize()
                    .cursor(Cursor.Pointer)
                    .position(Position.Absolute)
                    .zIndex(Constants.ZIndex.normalZIndex)
            )

            Box(
                modifier = Modifier
                    .size(Dimen.semiLargeIconSize2.px)
                    .position(Position.Absolute)
                    .zIndex(Constants.ZIndex.extraLargeZIndex)
                    .bottom(Dimen.semiExtraExtraLargePadding)
                    .left(Dimen.semiExtraExtraLargePadding)
                    .circleHoverAroundItem(
                        padding = 0.px,
                        onClick = { onCloseDataAssistantButtonClick() }
                    )
            ) {
                VectorIcon(
                    modifier = Modifier.cursor(Cursor.Pointer),
                    pathData = Res.PathIcon.restoMateClose,
                    width = Dimen.mediumIconSize,
                    height = Dimen.mediumIconSize,
                    color = Theme.ActionDisabled.hex
                )
            }
        }
    }
}
